function skipToContent(e) {
  e.preventDefault();
  const skipLink = e.currentTarget;
  const hash = skipLink.hash || skipLink.getAttribute("href") || "";
  const id = hash.replace(/^#/, "");

  // Forsøker ID‐lookup
  let targetEl = id ? document.getElementById(id) : null;
  // Fallback: første <main> i DOM
  if (!targetEl) {
    targetEl = document.querySelector("main");
  }
  // Alternativ fallback: element med id som begynner på "main-"
  if (!targetEl) {
    targetEl = document.querySelector("[id^=\"main-\"]");
  }

  if (!targetEl) {
    console.warn(`skipToContent: Ingen <main> eller element med id="${id}" funnet.`);
    return;
  }

  const hadTab = targetEl.hasAttribute("tabindex");
  if (!hadTab) targetEl.setAttribute("tabindex", "-1");
  targetEl.focus();
  if (!hadTab) targetEl.removeAttribute("tabindex");
}

export default skipToContent;
